import { Pipe, PipeTransform } from '@angular/core';

/* Usage:
    let item of array | orderBy: 'key';
OR, definine a custom order:
    let item of array | orderBy: 'key': ['value1', 'value2']; 
*/

@Pipe({
    name: 'orderBy'
})
export class RaptorOrderByPipe implements PipeTransform {
    transform<T>(array: T[], sortBy: keyof T, order?: 'asc' | 'desc' | Array<T[keyof T]>): T[] {
        if (!array || !sortBy) return array;

        return array.sort((a, b) => {
            const valueA = a[sortBy];
            const valueB = b[sortBy];

            // Handle explicit order array
            if (Array.isArray(order)) {
                const indexA = order.indexOf(valueA);
                const indexB = order.indexOf(valueB);

                // If both values are in the explicit order array, compare their indices
                if (indexA !== -1 && indexB !== -1) {
                    return indexA - indexB;
                }

                // If one value is in the explicit order array, prioritize it
                if (indexA !== -1) return -1;
                if (indexB !== -1) return 1;
            }

            // Handle default ascending or descending order
            const sortOrder = order === 'desc' ? -1 : 1;

            if (typeof valueA === 'string' && typeof valueB === 'string') {
                return sortOrder * valueA.localeCompare(valueB);
            }

            return sortOrder * ((valueA as any) - (valueB as any));
        });
    }
}